export const educationData = [
    {
        id: 1,
        institution: 'Booker Academy',
        course: 'Higher Secondary Education',
        startYear: '2015',
        endYear: '2019'
    },
    {
        id: 2,
        institution: 'Moringa School',
        course: 'Software Development',
        startYear: '2020',
        endYear: '2021'
    },
]